import { render, staticRenderFns } from "./ItalicSubheader.vue?vue&type=template&id=69b190dc&scoped=true&"
import script from "./ItalicSubheader.vue?vue&type=script&lang=js&"
export * from "./ItalicSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b190dc",
  null
  
)

export default component.exports